import { createContext } from "react";

const UserContext = createContext({
    name : 'Ashish Ranjan',
    email : 'ashishsingh829585@gmail.com'
})

export default UserContext;